import { createFileRoute } from '@tanstack/react-router'
import { guardStudentOnly } from '@/lib/auth/routeGuards'
import StudentAttendanceView from '@/components/studentPage/StudentAttendanceView'

export const Route = createFileRoute('/student/attendance/')({
  component: StudentAttendanceView,
  beforeLoad: guardStudentOnly,
})
